var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gat-tab',{attrs:{"items":_vm.items,"show-in-toolbar":_vm.showInToolbar}})
}
var staticRenderFns = []

export { render, staticRenderFns }